// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"2d5265d0e6cfbea6c35b","303":"eb5cf874d8e8dba17604","495":"020b7eb27ba17c369e54","826":"e8d918c3b34bea95e0c0","946":"2b7bb73c6317b307ddd0"}[chunkId] + ".js";
};